import { TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';

/**
 * As part of https://roche-ds.atlassian.net/browse/EXTCWP-644 we should standardize the tracking
 * and add missing Adobe Analytics tracking. Julian stated in ticket https://roche-ds.atlassian.net/browse/EXTCWP-431
 * that we should not add the Adobe tracking to the accordion-tabs component just yet,
 * as it is not implemented in the old component either.
 */
export const trackTabClick = (_, tabName: string) =>
  TrackingService.push({
    event: 'tabs_click',
    component_name: 'roche-accordion-tabs',
    value: tabName,
  });

export const trackAccordionToggle = (_, panelName: string) =>
  TrackingService.push({
    event: 'accordion_click',
    component_name: 'roche-accordion-tabs',
    value: panelName,
  });
